module.exports = __webpack_public_path__ + "assets/images/pages/enqsta/icon-enqsta-2.png?d24906ae";